////////LIBRARY/////////
import { isUndefined } from 'lodash'
///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import {
	globalLoadingActionCreators,
	errorManagerActionCreators,
	toastSuccessActionCreators,
	initKioskCreationAddItemsActionCreators,
} from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const postKioskCreationItems = function* ({ payload }) {
	const bodyMessage = payload.filters

	const user = yield select(selectIdsUser)
	const apiCall = R.POST_KIOSK_ADD_ITEMS(payload.requestId, payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMessage)

		yield put(initKioskCreationAddItemsActionCreators.postKioskCreationItemsSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationAddItemsActionCreators.postKioskCreationItemsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const putKioskLinkItems = function* ({ payload }) {
	const requestId = payload.requestId
	const itemId = payload.itemId
	const user = yield select(selectIdsUser)

	const MsgParams = 'toast__itemCatalog__distributor__link_addItem'
	const apiCall = R.PUT_KIOSK_LINK_ITEMS(requestId, itemId)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(initKioskCreationAddItemsActionCreators.putKioskLinkItemsSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationAddItemsActionCreators.putKioskLinkItemsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const putKioskUnlinkItems = function* ({ payload }) {
	const requestId = payload.requestId
	const distriItemId = payload.distriItemId
	const user = yield select(selectIdsUser)

	const MsgParams = 'toast__itemCatalog__distributor__link_removeItem'
	const apiCall = R.PUT_KIOSK_UNLINK_ITEMS(requestId, distriItemId)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(initKioskCreationAddItemsActionCreators.putKioskUnlinkItemsSuccess(data.data))

		if (isUndefined(data.data.errorCode)) {
			yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
		}
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationAddItemsActionCreators.putKioskUnlinkItemsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const getKioskItemsValidate = function* ({ payload }) {
	const requestId = payload.requestId

	const user = yield select(selectIdsUser)

	const MsgParams = 'toast__initKiosk__kioskCreation_items_validate'
	const redirectRequest =
		payload.redirectTest === 'customer'
			? `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskImplantation}/${requestId}`
			: `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskImplantation}/${requestId}`

	const apiCall = R.GET_KIOSK_ITEMS_VALIDATE(requestId)
	//const apiCall       = R.PUT_SAVE_BANK_DETAILS(requestId);

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationAddItemsActionCreators.getKioskItemsValidateSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams, redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationAddItemsActionCreators.getKioskItemsValidateFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_KIOSK_ADD_ITEMS, postKioskCreationItems)
	yield takeLatest(ActionsTypes.PUT_KIOSK_LINK_ITEMS, putKioskLinkItems)
	yield takeLatest(ActionsTypes.PUT_KIOSK_UNLINK_ITEMS, putKioskUnlinkItems)
	yield takeLatest(ActionsTypes.GET_KIOSK_ITEMS_VALIDATE, getKioskItemsValidate)
}

export default sagas
